export default {
  type: 'items',
  component: 'accordion',
  items: {
    data: {
      uses: 'data',
      items: {
        dimensions: {
          translation: 'Common.Fields',
        },
      },
    },
  },
};
